import { TID } from '@/lib/testIds';

export default function Introduction() {
  return (
    <section
      data-testid={TID.intro}
      className="py-24 md:py-32"
    >
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <p className="eyebrow mb-8 reveal">The Philosophy</p>
        <h2
          className="font-display font-semibold text-text reveal tracking-tight leading-[1.02]"
          style={{ fontSize: 'clamp(36px, 6vw, 92px)' }}
        >
          Strategy is only valuable{' '}
          <span className="text-ember">when it becomes execution.</span>
        </h2>
      </div>
    </section>
  );
}
